import type { ConfigProps } from '../../configTypes';
import type { TransformedItemPost } from '../types';
import fetchDefaultContributor from '../queries/fetchDefaultContributor';

function hasContributorName(post: TransformedItemPost): boolean {
  const first = post.contributors?.[0] as { name?: string } | undefined;
  return Boolean(first?.name?.trim());
}

/**
 * Attach the CMS default contributor name when posts lack one.
 * Fetches at most once; does not overwrite existing names.
 */
export async function withDefaultContributors(
  posts: TransformedItemPost[],
  config: ConfigProps,
): Promise<TransformedItemPost[]> {
  if (!posts.length || posts.every(hasContributorName)) {
    return posts;
  }

  let defaultTitle: string | undefined;
  try {
    const defaultContributor = await fetchDefaultContributor(config);
    defaultTitle = defaultContributor?.title?.trim() || undefined;
  } catch {
    return posts;
  }

  if (!defaultTitle) {
    return posts;
  }

  return posts.map((post) =>
    hasContributorName(post)
      ? post
      : { ...post, contributors: [{ name: defaultTitle }] },
  );
}
